import r from "./DoubleBounce.vue2.js";
import { openBlock as l, createElementBlock as s, normalizeStyle as o, createElementVNode as n } from "vue";
/* empty css                  */
import i from "../../../_virtual/_plugin-vue_export-helper.js";
function p(e, t, c, u, a, d) {
  return l(), s("div", {
    class: "ap-spinner-double-bounce",
    style: o({
      width: e.spinnerSize,
      height: e.spinnerSize
    })
  }, [
    n("div", {
      class: "ap-spinner-double-bounce-bounce1",
      style: o({ backgroundColor: e.spinnerColor })
    }, null, 4),
    n("div", {
      class: "ap-spinner-double-bounce-bounce2",
      style: o({ backgroundColor: e.spinnerColor })
    }, null, 4)
  ], 4);
}
const k = /* @__PURE__ */ i(r, [["render", p]]);
export {
  k as default
};
